import {
  DELETE_IMAGE_SUCCESS,
  SEND_LISTED_IMAGES_DATA_SUCCESS,
  RECEIVE_IMAGESTORE_URL,
  REORDER_PRODUCT_IMAGES,
} from '../../constants/ActionTypes';

export default function publishingMediaReducer(state, action) {
  switch (action.type) {
    case DELETE_IMAGE_SUCCESS:
      return {
        ...state,
        receivedPublishData: {
          ...state.receivedPublishData,
          [action.attribute]: state.receivedPublishData[
            action.attribute
          ].filter((x) => x.id !== action.id),
        },
        isSaving: false,
        isSaved: true,
        isNotSaved: false,
      };

    case SEND_LISTED_IMAGES_DATA_SUCCESS:
      return {
        ...state,
        receivedPublishData: {
          ...state.receivedPublishData,
          [action.attribute]: state.receivedPublishData[action.attribute]
            .map((x) => {
              if (x.id === action.data.id) {
                return action.data;
              }
              if (action.data.cover) {
                return { ...x, cover: false };
              }
              return x;
            })
            .sort((a, b) => a.id - b.id)
            .sort((a, b) => b.cover - a.cover),
        },
        isSaving: false,
        isSaved: true,
        isNotSaved: false,
      };

    case RECEIVE_IMAGESTORE_URL: {
      const { imageId } = action;
      const images = [...state.receivedPublishData.images];
      const index = images.length > imageId ? imageId : images.length;
      images.splice(index, 0, ...action.images);

      return {
        ...state,
        receivedPublishData: {
          ...state.receivedPublishData,
          images,
        },
        isSaving: false,
        isSaved: true,
        isNotSaved: false,
      };
    }

    case REORDER_PRODUCT_IMAGES: {
      const { imageId, newImageId, isUpload } = action;
      if (isUpload) {
        return state;
      }

      const images = [...state.receivedPublishData.images];
      if (images.length >= newImageId && images.length > imageId) {
        const tmpImage = images.splice(imageId, 1)[0];
        images.splice(newImageId, 0, tmpImage);
      }

      return {
        ...state,
        receivedPublishData: {
          ...state.receivedPublishData,
          images,
        },
      };
    }

    default:
      return state;
  }
}
